import { render, staticRenderFns } from "./GrupoHeader.vue?vue&type=template&id=3abcd226"
import script from "./GrupoHeader.vue?vue&type=script&lang=js"
export * from "./GrupoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports